/* oxlint-disable */
import { createClient, groq } from 'next-sanity';

import { apiVersion, dataset, projectId } from './env';

const client = createClient({
  projectId,
  dataset,
  useCdn: true,
  apiVersion,
});

export async function getSanityPosts(app:string) {
  const data = await client.fetch(
    groq`*[_type == "termsandconditions" && app == $app]{
            _id,
            title,
            "slug" : slug.current,
            body,
            orderRank,
            mainImage{
                asset->{
                    _id,
                    url
                }
            },
            app
        }`,
    { app },
  );
  return data;
}

export async function getSanityPrivacyPolicy(app:string) {
  const data = await client.fetch(
    groq`*[_type == "privacyPolicy" && app == $app]{
            _id,
            title,
            "slug" : slug.current,
            body,
            orderRank,
            mainImage{
                asset->{
                    _id,
                    url
                }
            },
            app
        }`,
    { app },
  );
  return data;
}

export async function getResponsibility(app:string) {
  const data = await client.fetch(
    groq`*[_type == "responsiblegaming" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}
export async function getKycpolicies(app:string) {
  const data = await client.fetch(
    groq`*[_type == "kycpolicies" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}

export async function getMoneyLaundering(app:string) {
  const data = await client.fetch(
    groq`*[_type == "moneylaundering" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}

export async function getDisputeResolutionPost(app:string) {
  const data = await client.fetch(
    groq`*[_type == "disputeresolution" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}

export async function getBettinglimit(app:string) {
  try {
    const data = await client.fetch(
      groq`*[_type == "bettinglimit" && app == $app]{
              _id,
              title,
              orderRank,
              body,
              app
          }`,
      { app },
    );
    return data;
  } catch (error: any) {
    console.log('🚀 ~ getBettinglimit ~ error:', error);
    return [];
  }
}

export async function getFrequentQuestions(app:string) {
  const data = await client.fetch(
    groq`*[_type == "frequentquestions" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}

export async function getBettingrules(app:string) {
  const data = await client.fetch(
    groq`*[_type == "bettingrules" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}

export async function getDepositsWithdrawals(app:string) {
  const data = await client.fetch(
    groq`*[_type == "depositsWithdrawals" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}

export async function getCategory(app:string) {
  const data = await client.fetch(
    groq`*[_type == "bonustermsandcond" && app == $app]{
            _id,
            title,
            orderRank,
            body,
            app
        }`,
    { app },
  );
  return data;
}

export async function getBannerHomePage() {
  const data = await client.fetch(
    groq`*[_type == "bannerHomePage" &&
            app == "hondubet"]{
             _id,
             title,
             startDate,
             orderRank,
             endDate,
             urlRedirection,
             "alt": image.alt,
             "imageUrl": image.asset->url,
             app,
             isMobile,
             bannerType
         }`,
  );
  return data;
}

export async function getBannerSportBook() {
  const data = await client.fetch(
    groq`*[_type == "bannerSportBook" && app == "hondubet"]{
             _id,
             title,
             "alt": image.alt,
             "imageUrl": image.asset->url,
             app,
             isMobile
         }`,
  );
  return data;
}

export async function getBannerCasino() {
  const data = await client.fetch(
    groq`*[_type == "bannerCasino" && app == "hondubet"]{
             _id,
             title,
             startDate,
             orderRank,
             endDate,
             urlRedirection,
             "alt": image.alt,
             "imageUrl": image.asset->url, 
             app,
             isMobile
         }`,
  );
  return data;
}

export async function getBannerSport() {
  const data = await client.fetch(
    groq`*[_type == "bannerSport"]{
             _id,
             title,
             startDate,
             orderRank,
             endDate,
             urlRedirection,
             "alt": image.alt,
             "imageUrl": image.asset->url,
             app
         }`,
  );
  return data;
}

export async function getPromotions() {
  const data = await client.fetch(
    groq`*[_type == "promotions"]{ // TODO: cambiar nombre en app
             _id,
             title,
             startDate,
             orderRank,
             endDate,
             urlRedirection,
             body,
             "alt": image.alt,
             "imageUrl": image.asset->url,
             app
         }`,
  );
  return data;
}

export async function getSorteos() {
  const data = await client.fetch(
    groq`*[_type == "sorteos"]{ // TODO: cambiar nombre en app
             _id,
             title,
             startDate,
             orderRank,
             endDate,
             id_promotion,
             body,
             urlSport,
             urlCasino,
             "alt": image.alt,
             "imageUrl": image.asset->url,
             app
         }`,
  );
  return data;
}

export async function getTournaments() {
  const data = await client.fetch(
    groq`*[_type == "tournaments"]{
             _id,
             orderRank,
             title,
             startDate,
             endDate,
             slug,
             currency,
             currencyExchange,
             isNetwork,
             provider,
             rules,
             prizePool,
             "alt": imageLobby.alt,
             "imageUrl": imageLobby.asset->url,
             "altLanding": imageLanding.alt,
             "imageUrlLanding": imageLanding.asset->url,
             app
         }`,
  );
  return data;
}
export async function getCampaings(app:string) {
  const data = await client.fetch(
    groq`*[_type == "campaing" && app == $app]{
            _id,
            campaign_id,
            orderRank,
            body,
            app,
            enviroment,
            type,
            title,
        }`,
    { app },
  );
  return data;
}

export async function getJackpot() {
  const data = await client.fetch(
    groq`*[_type == "jackpots"]{
    _id,
    "imageLanding": imageLanding.asset->url,
    }`,
  );
  return data;
}
